<template>
  <div>
    <div>
      <h1 class="">{{ t('contact_faq.course') }}</h1>
      <div class="px-2 pt-2 pb-1 text-gray-500">{{selectCourseCategory()}}</div>
      <hr>
    </div>
    <div>
      <h1 class="mt-4">{{ t('word.contents') }}</h1>
      <div class="px-2 pt-2 pb-1 text-gray-500">{{selectCategory()}}</div>
      <hr>
    </div>
    <div>
      <h1 class="mt-4">{{ t('word.subject') }}</h1>
      <div class="px-2 pt-2 pb-1 text-gray-500">{{store.state.contact.contact.subject}}</div>
      <hr>
    </div>
    <div>
      <h1 class="mt-4">{{ t('word.body') }}</h1>
      <div style="white-space:pre-wrap; word-wrap:break-word;" class="px-2 pt-2 pb-1 text-gray-500">{{store.state.contact.contact.body}}</div>
      <hr>
    </div>
    <div class="flex items-center justify-end mt-10 mr-2">
      <button type="button" class="bg-gray-200 hover:bg-gray-300 text-gray-800 py-1.5 px-4 rounded disabled:opacity-75 mr-2" @click="store.dispatch('contact/contactConfirmOff')">キャンセル</button>
      <button :disabled="btnDisabled" type="button" class="bg-blue-500 hover:bg-blue-400 text-white py-1.5 px-4 rounded disabled:opacity-75" @click="onComplete()">
        <div class="flex">
          <template v-if="btnDisabled">
            <base-svg-icon class="w-6 animate-spin mr-1 p-0.5" :path="mdiLoading" />
          </template>
          <div class="whitespace-nowrap">
            送信
          </div>
        </div>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ALERT_COLORS } from '@/store/base'
import { useI18n } from 'vue-i18n'
import { ElNotification } from 'element-plus'

import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import { HOME_PATH } from '@/router/routes'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import { mdiLoading } from '@mdi/js'

export default defineComponent({
  components: { BaseSvgIcon },
  setup() {
    const router = useRouter()
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)

    const onComplete = (() => {
      btnDisabled.value = true
      axios
        .post('/contact', store.state.contact.contact)
        .then(() => {
          // store.commit('base/setAlertMessages', { messages: [t('contact.success')], persistent: true, color: ALERT_COLORS.info })
          router.push(HOME_PATH)
          ElNotification({
            title: '問い合わせが完了しました。',
            message: '詳細はメールにてご確認ください。',
            type: 'success',
          })
          store.dispatch('contact/contactCompleteOn')
          store.commit('contact/setcontact_category_id', '')
          store.commit('contact/setcontact_course_id', '')
          store.commit('contact/setSubject', '')
          store.commit('contact/setBody', '')
          store.dispatch('contact/contactConfirmOff')
        })
        .finally(() => {
          btnDisabled.value = false
        })
    })

    const selectCategory = () => {
      return Array.isArray(store.state.contact.category) ? store.state.contact.category.find(category => category.value === store.state.contact.contact.contact_category_id)?.text : ''
    }
    const selectCourseCategory = () => {
      return Array.isArray(store.state.contact.course) ? store.state.contact.course.find(course => course.value === store.state.contact.contact.contact_course_id)?.text : ''
    }

    return {
      t,
      onComplete,
      btnDisabled,
      store,
      selectCategory,
      selectCourseCategory,
      mdiLoading,
    }
  },
})
</script>
